import React from 'react';

import { Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';

import ColorButton from '@/components/common/elements/ColorButton';
// import classes from '@/components/RemoveVNR/style.module.scss';

const RemoveVNRComponent = ({ error, validationSchema, handleSubmit, intl }) => (
  <div className="flex flex-col">
    <h3 className="text-[1.25em] font-bold text-[#393939] mb-6">
      {intl.formatMessage({ id: 'REMOVE_VNR' })}
    </h3>
    <Formik
      initialValues={{ category: '', observation: '' }}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {({ errors, isSubmitting }) => (
        <Form className="flex flex-col space-y-5">
          <div className="flex flex-col px-0">
            <label htmlFor="category" className="text-[0.75rem] font-bold uppercase text-[#393939] mb-1">
              {intl.formatMessage({ id: 'REASON' })}*
            </label>
            <Field
              as="select"
              name="category"
              id="category"
              className="h-12 px-2 border border-[#e3e3e3] rounded-[3px] bg-white font-sans text-[0.875rem] font-semibold text-[#919191] focus:outline-none focus:border-[#4d8fca] transition-colors"
            >
              <option value=""></option>
              <option value="Vistoria remarcada">Vistoria remarcada</option>
              <option value="Vistoria realizada no mesmo dia">Vistoria realizada no mesmo dia</option>
              <option value="Erro do vistoriador">Erro do vistoriador</option>
              <option value="Outros">Outros</option>
            </Field>
            {errors?.category && (
              <div className="mt-2 text-[0.87rem] text-[#ed0000]">
                {error || errors.category}
              </div>
            )}
          </div>
          <div className="flex flex-col px-0">
            <label htmlFor="observation" className="text-[0.75rem] font-bold uppercase text-[#393939] mb-1">
              {intl.formatMessage({ id: 'MORE_INFORMATION' })}
            </label>
            <Field
              type="text"
              name="observation"
              id="observation"
              className="h-12 px-2 border border-[#e3e3e3] rounded-[3px] bg-white font-sans text-[0.875rem] font-semibold text-[#919191] focus:outline-none focus:border-[#4d8fca] transition-colors"
            />
            {(error || errors.observation) && (
              <div className="mt-2 text-[0.87rem] text-[#ed0000]">
                {error || errors.observation}
              </div>
            )}
          </div>
          <div className="flex justify-end items-center mt-6">
            <ColorButton type="submit" color="green" isBusy={isSubmitting}>
              {intl.formatMessage({ id: 'SEND' })}
            </ColorButton>
          </div>
        </Form>
      )}
    </Formik>
  </div>
);

RemoveVNRComponent.propTypes = {
  error: PropTypes.string,
  validationSchema: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

RemoveVNRComponent.defaultProps = {
  error: null,
};

export default RemoveVNRComponent;
